var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4 4 C 2.895 4 2 4.895 2 6 L 2 7.7324219 L 3 8.359375 L 4 8.9863281 L 12 14 L 20 9.0195312 L 21 8.3964844 L 22 7.7753906 L 22 6 C 22 4.895 21.105 4 20 4 L 4 4 z M 4 6 L 20 6 L 20 6.7695312 L 12 11.748047 L 4 6.734375 L 4 6 z M 2 10.091797 L 2 18 C 2 19.105 2.895 20 4 20 L 20 20 C 21.105 20 22 19.105 22 18 L 22 10.130859 L 20 11.375 L 20 18 L 4 18 L 4 11.345703 L 2 10.091797 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMail);
export default __webpack_public_path__ + "static/media/ShareMail.ee0ad488c1a8d1fd0235c57b0284bca5.svg";
export { ForwardRef as ReactComponent };